import { BaseEntity } from './base-entity';

export class RiskBand extends BaseEntity {
  color: string;
  numericValue: number;
  rounding: boolean;
}
